import { Moon, RefreshCw, Sun } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import { reloadServer } from "@client/api/endpoints";
import { useDark } from "@client/hooks/useDark";
import { t } from "@client/lib/dictionary";
import { useUserStore } from "@client/store/user";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@client/components/ui/alert-dialog";
import { Label } from "@client/components/ui/label";
import { Switch } from "@client/components/ui/switch";

const UserTabPanel: React.FC = () => {
  const { toggleDark, dark } = useDark();
  const user = useUserStore((s) => s.user);
  const isAdmin = !!(user && typeof user === "object" && user.role === "ADMIN");
  const [restarting, setRestarting] = useState(false);

  const handleRestart = async () => {
    setRestarting(true);
    try {
      await reloadServer();
      toast.success("Restart spuštěn.");
    } catch {
      toast.error("Restart selhal — chybí oprávnění?");
    } finally {
      setRestarting(false);
    }
  };

  return (
    <div className="flex flex-col">
      {/* Dark mode */}
      <div className="flex items-center justify-between py-2.5 border-b border-border">
        <div className="flex items-center gap-2">
          {dark ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
          <Label htmlFor="dark-toggle">{t.settings.darkMode}</Label>
        </div>
        <Switch id="dark-toggle" checked={dark} onCheckedChange={(v) => toggleDark(v)} />
      </div>

      {/* Notifikace: viz samostatný tab "Push notifikace" (PushTabPanel). */}

      {isAdmin && (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button
              type="button"
              className="flex items-center justify-between py-2.5 border-b border-border hover:bg-accent rounded transition-colors text-left -mx-2 px-2"
            >
              <div className="flex items-center gap-2">
                <RefreshCw className="h-5 w-5" />
                <span className="text-sm font-medium">{t.settings.restartServer}</span>
              </div>
            </button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{t.settings.restartConfirm}</AlertDialogTitle>
              <AlertDialogDescription>
                Server se restartuje a všechna spojení (WS, MQTT) se znovu naváží. Krátce nedostupné.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>{t.app.cancel}</AlertDialogCancel>
              <AlertDialogAction onClick={handleRestart} disabled={restarting}>
                {restarting ? t.app.loading : t.app.confirm}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
};

export default React.memo(UserTabPanel);
